import { useState, useEffect } from 'react'
import useAccount from 'hooks/useAccount'
import useGoogleMaps from 'hooks/useGoogleMaps'

const useMapCenter = () => {
  const { geocode } = useGoogleMaps()

  const [center, setCenter] = useState<google.maps.LatLng | null>(null)

  const getCenter = (address: string) => {
    if (!geocode || !address) {
      return
    }

    geocode({ address }, ([result]) => {
      const { location } = result?.geometry ?? {}
      setCenter(location ?? null)
    })
  }

  const { accountAddress, latitude, longitude } = useAccount()

  useEffect(() => {
    if (!geocode || !accountAddress) {
      return
    }
    if (latitude && longitude) {
      // If latitude and longitude are available, use them directly
      setCenter(new google.maps.LatLng(Number(latitude), Number(longitude)))
    } else {
      // Otherwise, geocode the address
      getCenter(accountAddress)
    }
  }, [geocode, accountAddress, latitude, longitude])

  return { center } as const
}

export default useMapCenter
